import noop from 'lodash/noop';
import { RefObject, useCallback, useRef } from 'react';

import { EnhancedMedia } from 'src/components/EnhancedMedia/EnhancedMedia';

export type MediaHover = Readonly<{
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  enhancedMediaRef?: RefObject<EnhancedMedia>;
}>;

export const initialValue: MediaHover = {
  handleMouseEnter: noop,
  handleMouseLeave: noop,
};

export const useMediaHover = (ref?: RefObject<EnhancedMedia>): MediaHover => {
  const enhancedMediaDefault = useRef<EnhancedMedia>(null);

  const enhancedMediaRef = ref && ref.current ? ref : enhancedMediaDefault;

  const handleMouseEnter = useCallback(() => {
    const { current } = enhancedMediaRef;
    if (current) {
      current.play();
    }
  }, [enhancedMediaRef]);

  const handleMouseLeave = useCallback(() => {
    const { current } = enhancedMediaRef;
    if (current) {
      current.pause();
      current.reloadMedia();  // force-reload media so background image gets shown again
    }
  }, [enhancedMediaRef]);

  return {
    enhancedMediaRef,
    handleMouseEnter,
    handleMouseLeave,
  };
};
